module.exports = __webpack_public_path__ + "img/blue_bg1.cf46d32d.png";